import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service.component',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/component/Service/service.component.ts